import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useField } from "react-final-form";
import { AddressInput } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function AddressInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else AddressInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const handleChange = (input, onChange)=>(value)=>{
        input.onChange(value);
        if (onChange) onChange(value);
    };
const requestErr = 'Сервис подсказки адресов временно недоступен. Повторите попытку позднее';
const completenessErr = 'Нужно выбрать адрес из списка с содержанием: индекс, регион, населенный пункт, улица, дом/квартира';
const MAX_CACHE_SIZE = 50;
const lruSet = (cache, key, value)=>{
    cache.set(key, value);
    if (cache.size > MAX_CACHE_SIZE) {
        const oldestKey = cache.keys().next().value;
        if (void 0 !== oldestKey) cache.delete(oldestKey);
    }
};
const AddressInput_AddressInput = (props)=>{
    const { name, label, labelIcon, onChange, placeholder, disabled = false, required = false, loading = false, tooltip, helperText, noOptionsText, renderOption, limit = 50, minInputValueLength = 1, addressCompleteness = 8, mask, validate, validationWithoutTouch = false, validationWhenDisabled = false, noAddressCompletenessValidation, catalogName, loadItems } = props, rest = _object_without_properties(props, [
        "name",
        "label",
        "labelIcon",
        "onChange",
        "placeholder",
        "disabled",
        "required",
        "loading",
        "tooltip",
        "helperText",
        "noOptionsText",
        "renderOption",
        "limit",
        "minInputValueLength",
        "addressCompleteness",
        "mask",
        "validate",
        "validationWithoutTouch",
        "validationWhenDisabled",
        "noAddressCompletenessValidation",
        "catalogName",
        "loadItems"
    ]);
    const cacheItems = useRef(new Map()).current;
    const requestCache = useRef(new Map()).current;
    const dedupedLoadItems = (filter)=>{
        const key = `${filter.query}|${filter.offset}|${filter.limit}`;
        const cached = requestCache.get(key);
        if (cached) return cached;
        const request = loadItems(filter).catch((error)=>{
            requestCache.delete(key);
            throw error;
        });
        lruSet(requestCache, key, request);
        return request;
    };
    const internalValidErr = (value)=>_async_to_generator(function*() {
            if (!value) return;
            if (value && (null == value ? void 0 : value.length) < minInputValueLength) return 'Минимальное количество символов > 1';
            try {
                let list = [];
                if (value && cacheItems.has(value)) list = cacheItems.get(value);
                else {
                    list = yield dedupedLoadItems({
                        limit,
                        offset: 0,
                        query: (value || '').replace(/_+/g, '').trim()
                    });
                    if (!value) return;
                    lruSet(cacheItems, value, list);
                }
                const item = null == list ? void 0 : list.find((el)=>el.value === value);
                const completeness = (null == item ? void 0 : item.addressCompleteness) || 0;
                if (!noAddressCompletenessValidation && addressCompleteness > completeness) return completenessErr;
            } catch (unused) {
                return noAddressCompletenessValidation ? `Поиск городов в ${'SMARTWAY' === catalogName ? 'Smartway' : 'Trivio'} временно недоступен. Обратитесь, пожалуйста, в техподдержку вашей компании` : requestErr;
            }
        })();
    const { input, meta } = useField(name, _object_spread({
        validate: composeValidators(validate ? [
            validate,
            internalValidErr
        ] : [
            internalValidErr
        ])
    }, rest));
    const touched = meta.touched || meta.error === requestErr;
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : touched && !!meta.error;
    return /*#__PURE__*/ jsx(AddressInput, _object_spread_props(_object_spread({}, input), {
        label: label,
        labelIcon: labelIcon,
        onChange: handleChange(input, onChange),
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        loading: loading,
        tooltip: tooltip,
        error: renderError,
        helperText: renderError && meta.error || helperText,
        noOptionsText: noOptionsText,
        renderOption: renderOption,
        loadItems: dedupedLoadItems,
        limit: limit,
        mask: mask,
        addressCompleteness: addressCompleteness,
        minInputValueLength: minInputValueLength
    }));
};
export { AddressInput_AddressInput as AddressInput };
